import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "./ui/button";
import NotificationsBell from "./NotificationsBell";

export default function Layout({ children }) {
  const { user, usage, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const NavLink = ({ to, label, testid }) => {
    const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
    return (
      <Link to={to} data-testid={testid}
        className={`px-4 py-2 rounded-md font-display font-semibold text-base tracking-wide uppercase transition-colors ${active ? "bg-red-600 text-white" : "text-white hover:bg-neutral-800"}`}>
        {label}
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white">
      <header className="sticky top-0 z-50 bg-neutral-950/95 backdrop-blur border-b border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-red-600 grid place-items-center font-display font-black text-white">R</div>
            <span className="font-display font-black text-2xl tracking-tight">REPSNAP</span>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {user?.role === "coach" ? (
              <NavLink to="/coach" label="Coach" testid="nav-coach" />
            ) : (
              <>
                {user && <NavLink to="/dashboard" label="Dashboard" testid="nav-dashboard" />}
                {user && <NavLink to="/upload" label="Upload" testid="nav-upload" />}
                {user && <NavLink to="/plan" label="Plan" testid="nav-plan" />}
                {user && <NavLink to="/progress" label="This week" testid="nav-progress" />}
              </>
            )}
            <NavLink to="/pricing" label="Pricing" testid="nav-pricing" />
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <>
                {usage && user.role !== "coach" && (
                  <div data-testid="usage-badge" className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-md border border-neutral-800 bg-neutral-900 text-sm">
                    {usage.unlimited ? <span className="text-red-500 font-semibold">UNLIMITED</span> :
                      <span><span className="text-white font-semibold">{usage.free_remaining}</span><span className="text-neutral-400"> free</span> · <span className="text-white font-semibold">{usage.credit_balance}</span><span className="text-neutral-400"> credits</span></span>}
                  </div>
                )}
                <NotificationsBell />
                <Button data-testid="logout-btn" variant="ghost" onClick={() => { logout(); nav("/"); }} className="h-11 text-white hover:bg-neutral-800">Log out</Button>
              </>
            ) : (
              <>
                <Button data-testid="header-login-btn" variant="ghost" className="h-11 text-white hover:bg-neutral-800" onClick={() => nav("/login")}>Log in</Button>
                <Button data-testid="header-signup-btn" className="h-11 bg-red-600 hover:bg-red-700 text-white font-semibold" onClick={() => nav("/register")}>Sign up</Button>
              </>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
      <footer className="border-t border-neutral-800 mt-16">
        <div className="max-w-7xl mx-auto px-6 py-6 text-neutral-500 text-sm flex flex-wrap gap-4 justify-between">
          <span>© 2026 REPSNAP</span>
          <span>Private by default · AI-assisted coaching, not a substitute for a human coach</span>
        </div>
      </footer>
    </div>
  );
}
